import { Component, Input, Output, OnInit, EventEmitter } from '@angular/core';
import { Review } from '../../model/Review';
import { CpdEntry } from '../../model/CpdEntry';
import { RevalidationItemType } from '../../model/RevalidationItemType';
import { revalidationItemTypes } from '../../model/revalidationItemTypes';
import { RevalidationItemTypeConfig } from '../../model/RevalidationItemTypeConfig';
import { ReviewStage } from '../../model/ReviewStage';
import { Feedback } from '../../model/Feedback';
import { PerformanceIndicator } from '../../model/PerformanceIndicator';
// declare const require;

@Component({
    selector: 'app-feedback-sections-readonly',
    templateUrl: './feedbackSectionsReadonly.component.html',
    styleUrls: ['./feedbackSections.scss'],
    standalone: false
})
export class FeedbackSectionsReadonlyComponent implements OnInit {

  @Input() review: Review;
  @Input() feedback: Feedback;
  @Output() onSelected = new EventEmitter<RevalidationItemTypeConfig>();

  sections: any[];
  selected: RevalidationItemTypeConfig;
  editing = false;
  PerformanceIndicator = PerformanceIndicator;

  ngOnInit() {

    const types = this.review.entries.reduce(
      (acc: Array<RevalidationItemType>, item: CpdEntry) => {
        if (acc.indexOf(item.type) === -1) {
          acc.push(item.type);
        }
        return acc;
      }, []);
    const sections = types.map(t => {
      const section: any = revalidationItemTypes.filter(r => r.type === t)[0];
      section.isFeedback = true;
      section.editing = false;
      return section;
    });
    const assessmentSection = { isAssessment: true, title: 'Final assessment', feedbackType: 'coreCriteriaFeedback', editing: false };
    if (this.review.stage === ReviewStage.QualityAssuranceCompleted || this.review.stage === ReviewStage.CoreCriteriaNotMet) {
      sections.unshift(assessmentSection);
    } else {
      sections.push(assessmentSection);
    }

    this.sections = sections;
    this.select(this.sections[0]);
  }



  helpClick($event, section) {
    section.helpVisible = !section.helpVisible;
    $event.stopPropagation();

  }


  select(item: RevalidationItemTypeConfig) {
    if (this.selected === item) {
      this.selected = undefined;
    } else {
      this.selected = item;
    }

    setTimeout(() => {
      this.onSelected.emit(this.selected);
    });
  }




}
